import getSettings from 'self-service-api/api/getSettings';
import { SETTINGS } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchSettingsRequestTypes = createRequestTypes(SETTINGS);
export const FetchSettingsActions = createRequestActions(FetchSettingsRequestTypes);
export const fetchSettings = () => makeFetchRequest({
  requestActions: FetchSettingsActions,
  fetch: getSettings
});